import { Download, Eye, EyeOff, HatGlasses, LoaderCircle } from 'lucide-preact'
import style from './FileList.module.css'
import { getDocumentUrl, getPostprocessorUrl, type DocumentClassification } from '../api/Api'

export type FileType = 'document' | 'postprocessor'
export type CheckboxState = 'unchecked' | 'checked' | 'forceUnchecked' | 'forceChecked'

export interface FileInformation {
  type: FileType
  name: string
  checkbox?: CheckboxState
  classification?: DocumentClassification
}

interface FileListElementProps {
  file: FileInformation
  onClick?: (file: FileInformation) => void
}

function FileListElement({ file, onClick }: FileListElementProps) {
  const url = file.type === 'document' ? getDocumentUrl(file.name) : getPostprocessorUrl(file.name);

  return (
    <li onClick={() => { if (onClick) { onClick(file); } }} class={onClick ? style.cursorPointer : ""}>
      {file.checkbox &&
        <input
          type="checkbox"
          checked={file.checkbox === 'checked' || file.checkbox === 'forceChecked'}
          disabled={file.checkbox === 'forceUnchecked' || file.checkbox === 'forceChecked'}
        />
      }
      {file.classification !== undefined &&
        <span class={style.fileClassification} title={`Classification: ${file.classification}`}>
          {file.classification === "Unclassified" && <Eye />}
          {file.classification === "Classified" && <EyeOff />}
          {file.classification === "TopSecret" && <HatGlasses />}
        </span>
      }
      <span class={style.fileName} title={`Select ${file.name} as input`}>
        {file.name}
      </span>
      <a title={`Download ${file.name}`} class="button" href={url} target="_blank" onClick={(e) => { e.stopPropagation(); }}>
        <Download size={16} />
      </a>
    </li>
  )
}

interface FileListProps {
  files: FileInformation[]
  loading?: boolean
  onFileClick?: (file: FileInformation) => void
}

export function FileList({ files, loading, onFileClick }: FileListProps) {
  return (
    <ul class={style.fileList}>
      {loading ? (
        <li class="loader"><LoaderCircle size={64} /></li>
      ) : (
        files.length === 0 ? (
          <li>There are no files in this directory.</li>
        ) : (
          files.map((file) => (
            <FileListElement key={file.name} file={file} onClick={onFileClick} />
          ))
        )
      )}
    </ul>
  )
}